
<template>
    <el-card shadow="never" class="box-card">
    <div slot="header" class="clearfix">
        <span>{{name}}</span>
    </div>
        <div class="text item paramContainer">
            <el-row :gutter="10">
                <el-col class="paramNameCol" :span="8">
                    URI
                </el-col>
                <el-col :span="16">
                    <el-input
                        type="textarea"
                        placeholder="Please input URI"
                        v-model="uris"
                        clearable>
                    </el-input>        
                </el-col>
            </el-row>
            <el-row :gutter="8">
                <el-col class="paramNameCol" :span="8">
                    Plus domain
                </el-col>
                <el-col :span="16">
                    <el-checkbox class="clickCheckbox" v-model="model.params.plus_domain"></el-checkbox>        
                </el-col>
            </el-row>
            <el-row :gutter="8">
                <el-col class="paramNameCol" :span="8">
                    Mode
                </el-col>
                <el-col :span="16">
                     <el-select v-model="model.params.mode"  placeholder="Select mode">
                        <el-option
                        v-for="item in modes"
                        :key="item"
                        :label="item"
                        :value="item">
                        </el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-row :gutter="8">
                <el-col class="paramNameCol" :span="8">
                    Search engine URI
                </el-col>
                <el-col :span="16">
                     <el-select v-model="model.params.se_uri"  placeholder="Select mode">
                        <el-option
                        v-for="item in engine"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-row :gutter="8">
                <el-col class="paramNameCol" :span="8">
                    Suggestions
                </el-col>
                <el-col :span="16">
                     <el-select v-model="model.params.use_suggestions"  placeholder="Select mode">
                        <el-option
                        v-for="item in suggestions"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-row :gutter="8">
                <el-col class="paramNameCol" :span="8">
                    Page depth
                </el-col>
                <el-col :span="16">
                    <el-input-number size="mini" v-model="model.params.page_depth"></el-input-number>        
                </el-col>
            </el-row>
            <el-row :gutter="8">
                <el-col class="paramNameCol" :span="8">
                    Required
                </el-col>
                <el-col :span="16">
                    <el-checkbox class="clickCheckbox" v-model="model.params.required"></el-checkbox>        
                </el-col>
            </el-row>
            <el-row :gutter="8">
                <el-col class="paramNameCol" :span="8">
                    Queries
                </el-col>
            </el-row>
            <el-row :gutter="8">
                <el-input
                    type="textarea"
                    class="textarea-stripe-container"
                    placeholder="Please input search queries"
                    autosize
                    v-model="queries">
                </el-input>
            </el-row>
            <el-collapse v-model="collapso_advanced">
                <el-collapse-item title="Advanced options" name="1">
                    <el-row :gutter="8">
                        <el-col class="paramNameCol" :span="9">
                            Topvisor Project ID
                        </el-col>
                        <el-col :span="15">
                            <el-input placeholder="Input Topvisor Project ID" v-model="model.params.tv_projectid" clearable></el-input>
                        </el-col>
                    </el-row>
                </el-collapse-item>
            </el-collapse>
            <el-row>
                <div class="tip">
                    No description here yet. The whole thing helps you search stuff on Google, that's it.
                </div>
            </el-row>
        </div>
    </el-card>    
</template>

<script>
import { mapState, mapGetters } from 'vuex';
export default {
    name: 'Google',
    props: {
        model: {
            type: Object,
            default: () => {}
        },
    },
    data () {
        return {
            name:'Search in Google',
            modes: ['random', 'table', 'uri_list'],
            textarea: '',
            queries: this.getQueries(),
            uris: this.prepareParam(this, 'uri'),
            collapso_advanced: false,
            engine: [
                {value:'https://www.google.com', name: 'google.com'},
                {value:'direct_url',             name: 'direct url'},
            ],
            suggestions: [
                {value:'never', name: 'never'},
                {value:'random', name: 'random'},
                {value:'always', name: 'always'},
            ],
        }
    },
    created() {
        if (!this.model || !this.model.params) {
            return;
        }
        // Если параметра required нет - то принудительно ставим галочку
        if (typeof this.model.params.required === 'undefined') {
            this.$set(this.model.params, 'required', true);
        }
    },
    methods: {
        getQueries() {
            //var lines = area.value.replace(/\r\n/g,"\n").split("\n");
            if (this.model.params.values.length === 0) {
                return "";
            }

            return this.model.params.values.join("\n");
        },
        updateQueries(event) {

        },
        queriesChanged(event) {
            
        }
    },
    computed: {
        ...mapState('bot', {
        bot: 'bot',
        project: 'project',
        error: 'error',
        loading: 'loading',
        }),
    },
    watch: {
        queries(newValue, oldValue) {
            this.model.params.values = newValue.replace(/\r\n/g,"\n").split("\n");
        },
        uris(newValue, oldValue) {
            this.model.params.uri = newValue.replace(/\r\n/g,"\n").split("\n");
        },
  },
}
</script>

<style lang="scss" scoped>
    .clickCheckbox {
        margin-top: 10px;
    }
</style>
